import 'swiper/swiper-bundle.css';

import { Skeleton } from '@material-ui/lab';
import type { PublicFileData } from '@mogul/api-client';
import React from 'react';
import SwiperCore, {
  Autoplay,
  EffectCoverflow,
  Navigation,
  Pagination,
} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import styles from './Carousel.module.css';
SwiperCore.use([Autoplay, Navigation, Pagination, EffectCoverflow]);

interface Props {
  items: PublicFileData[];
}

export const CarouselComponent: React.FC<Props> = props => {
  let { items } = props;

  items = items.map(i => {
    return {
      ...i,
      publicUrl: i.publicUrl.replace('d8r7g9tzupsfa', 'd2bhvhyqzg9zio'),
    };
  });

  return (
    <div className="flex flex-col justify-center overflow-x-hidden">
      <div
        className={`${styles.sectionHeader} fontVanguard font-bold w-full sm:w-8/12 sm:mx-auto px-10 sm:px-0 pb-10`}
      >
        Featured
      </div>
      <div className={`${styles.carouselContainer} sm:w-full`}>
        {!items.length ? (
          <div className="w-screen">
            <Skeleton variant="rect" height={300} />
          </div>
        ) : (
          <Swiper
            navigation={false}
            effect={'coverflow'}
            loop={true}
            coverflowEffect={{
              rotate: 20,
              stretch: 0,
              depth: 150,
              modifier: 1,
              slideShadows: false,
            }}
            autoplay={
              items.length > 1 && {
                delay: 3500,
                disableOnInteraction: false,
              }
            }
            slidesPerView={items.length > 1 ? 3 : 1}
            initialSlide={1}
            centeredSlides={true}
            grabCursor={true}
            slideToClickedSlide={true}
            breakpoints={{
              640: {
                slidesPerView: items.length > 1 ? 2 : 1,
                spaceBetween: 1,
              },
              768: {
                slidesPerView: items.length > 1 ? 2 : 1,
                spaceBetween: 5,
              },
              1400: {
                slidesPerView: items.length > 1 ? 3 : 1,
                spaceBetween: 10,
              },
            }}
          >
            {items.map((item, index) => (
              <SwiperSlide key={index}>
                {item.mimeType !== 'video/mp4' ? (
                  <img src={item.publicUrl} alt="" />
                ) : (
                  <video
                    autoPlay={true}
                    muted
                    playsInline
                    loop
                    src={item.publicUrl}
                  />
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
};
